module.exports = __webpack_public_path__ + "static/media/roc_bla_haz_lev.81ac79ae.png";